import React from "react";
import { Container } from "../../components/container/Container";
import Heading from "../../components/heading/Heading";

const ProgressBar = ({ segments, idx }) => {
  console.log(segments, idx);
  return (
    <Container className="text-left">
      <Heading level={5} className="text-xl font-semibold" children={segments.text} />
      <div className="w-full bg-gray-200 rounded-md overflow-hidden flex my-4">
        <div
          key={idx}
          className="h-2 transition-all duration-300 bg-[#0D283F]"
          style={{
            width: `${segments.value}%`,
          }}
        />
      </div>
    </Container>
  );
};

export default ProgressBar;
